// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"748":"6072ef9c","923":"fb97c5b6"}[chunkId] + ".chunk.js";
};